import { Icon, type IconPath } from '@nespresso-design-system/components';
import type { Product, ProductTechnology } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Options, Translations } from '@/widgets/ProductList/config';
import styles from './TechnologyLabelSection.module.scss';
import { icons } from '@/widgets/ProductList/filters/FilterBar/parts/TechnologyPicker/index.ts';
import useWidgetOptions from '@/widgets/hooks/useWidgetOptions';

type TechnologyContent = {
  labelKey: string;
  icon: IconPath;
};

type TechnologyLabelSectionProps = {
  product: Product;
};

const supportedTechnologies: Record<ProductTechnology, TechnologyContent> = {
  original: {
    labelKey: 'productList.cards.technologyLabel.original',
    icon: icons.original
  },
  vertuo: {
    labelKey: 'productList.cards.technologyLabel.vertuo',
    icon: icons.vertuo
  },
  pro: {
    labelKey: 'productList.cards.technologyLabel.pro',
    icon: icons.pro
  }
};

export default function TechnologyLabelSection({
  product
}: TechnologyLabelSectionProps) {
  const { displayTechnologyLabelOnProductCards } = useWidgetOptions<Options>();
  const technologyName =
    product.technologies[0]?.toLowerCase() as ProductTechnology;
  const technology = supportedTechnologies[technologyName];
  const { t } = useTranslations<Translations>();

  if (
    !displayTechnologyLabelOnProductCards ||
    product.technologies?.length !== 1 ||
    !technology ||
    product.hideTechnologyLabelOnProductCards
  ) {
    return null;
  }

  return (
    <div class={styles.technologyLabel}>
      <Icon icon={technology.icon} />
      {t(technology.labelKey)}
    </div>
  );
}
